// extracted by mini-css-extract-plugin
module.exports = {"shareOptions":"ShareInput-module_shareOptions_7614f"};